import { defineComponent as C, ref as x, computed as n, onMounted as p, onBeforeUnmount as _, h as N } from "vue";
import { useCarouselContext as R } from "./ghl-ui.es926.js";
import P from "./ghl-ui.es854.js";
import v from "./ghl-ui.es935.js";
const d = "CarouselItem", $ = (l) => {
  var t;
  return ((t = l.type) === null || t === void 0 ? void 0 : t.name) === d;
}, S = C({
  name: d,
  setup(l) {
    const {
      mergedClsPrefixRef: t
    } = P(l), e = R(v(d), `n-${v(d)}`), o = x(), s = n(() => {
      const {
        value: a
      } = o;
      return a ? e.getSlideIndex(a) : -1;
    }), i = n(() => e.isPrev(s.value)), r = n(() => e.isNext(s.value)), u = n(() => e.isActive(s.value)), c = n(() => e.getSlideStyle(s.value));
    p(() => {
      e.addSlide(o.value);
    }), _(() => {
      e.removeSlide(o.value);
    });
    function m(a) {
      const {
        value: f
      } = s;
      f !== void 0 && (e == null || e.onCarouselItemClick(f, a));
    }
    return {
      mergedClsPrefix: t,
      selfElRef: o,
      isPrev: i,
      isNext: r,
      isActive: u,
      index: s,
      style: c,
      handleClick: m
    };
  },
  render() {
    var l;
    const {
      $slots: t,
      mergedClsPrefix: e,
      isPrev: o,
      isNext: s,
      isActive: i,
      index: r,
      style: u
    } = this, c = [`${e}-carousel__slide`, {
      [`${e}-carousel__slide--current`]: i,
      [`${e}-carousel__slide--prev`]: o,
      [`${e}-carousel__slide--next`]: s
    }];
    return N("div", {
      ref: "selfElRef",
      class: c,
      role: "option",
      tabindex: "-1",
      "data-index": r,
      "aria-hidden": !i,
      style: u,
      // We use ts-ignore for vue-tsc, since it seems to patch native event
      // for vue components
      // @ts-expect-error vue's tsx has type for capture events
      onClickCapture: this.handleClick
    }, (l = t.default) === null || l === void 0 ? void 0 : l.call(t, {
      isPrev: o,
      isNext: s,
      isActive: i,
      index: r
    }));
  }
});
export {
  S as default,
  $ as isCarouselItem
};
